// Import all MUI icons once at the top
import {
  Home as HomeIcon,
  AddBusiness,
  CurrencyExchange,
  School as SchoolIcon,
  AccountCircle as AccountCircleIcon,
  People as PeopleIcon,
  DriveEta as DriveEtaIcon,
  MonetizationOn as MonetizationOnIcon,
  BarChart as BarChartIcon,
  Settings as SettingsIcon,
  Payments as PaymentsIcon,
  SupportAgent as SupportAgentIcon,
  Logout as LogoutIcon,
  CarRental as CarRentalIcon,
  Laptop as LaptopIcon,
  Receipt as ReceiptIcon,
  SportsEsports as GameIcon,
} from '@mui/icons-material';

// Map each role to its menu
export const menuConfig = {
  admin: [
    { label: 'Dashboard', icon: HomeIcon, path: '/admin' },
    { label: 'Branches', icon: AddBusiness, path: '/admin/branches' },
    { label: 'Departments', icon: AddBusiness, path: '/admin/departments' },
    { label: 'Charges', icon: CurrencyExchange, path: '/admin/charges' },
    { label: 'Courses', icon: SchoolIcon, path: '/admin/courses' },
    { label: 'Staff', icon: AccountCircleIcon, path: '/admin/staff' },
    {
      label: 'Students', icon: PeopleIcon, 
      children: [
        { label: 'All Students', path: '/admin/students' },
        { label: 'Filter Students', path: '/admin/student_filter' },
      ]
     },
    {
      label: 'Lessons',
      icon: SchoolIcon,
      children: [
        { label: 'Practical Lessons', path: '/admin/practical_lessons' },
        { label: 'Refresher Lessons', path: '/admin/refresher_lessons' },
      ],
    },
    {
      label: 'Finance',
      icon: MonetizationOnIcon,
      children: [
        { label: 'Payments', path: '/admin/transactions' },
        { label: 'Expenses', path: '/admin/expenses' },
      ],
    },
    {
      label: 'Financial Reports',
      icon: BarChartIcon,
      children: [
        { label: 'Cash Flow', path: '/admin/cashflow' },
        { label: 'Income Statement', path: '/admin/income_statement' },
      ],
    },
    { label: 'Vehicles', icon: DriveEtaIcon, path: '/admin/vehicles' },
    { label: 'Settings', icon: SettingsIcon, path: '/admin/settings' },
    { label: 'Profile', icon: AccountCircleIcon, path: '/admin/profile' },
  ],

  instructor: [
    { label: 'Dashboard', icon: HomeIcon, path: '/instructor' },
    { label: 'My Courses', icon: SchoolIcon, path: '/instructor/my-courses' },
    {
      label: 'Enrolled Students',
      icon: PeopleIcon,
      children: [{ label: 'View Students', path: '/instructor/my-students' }],
    },
    { label: 'Lessons', icon: DriveEtaIcon, path: '/instructor/mylessons' },
    { label: 'Profile', icon: AccountCircleIcon, path: '/instructor/profile' },
    { label: 'Support', icon: SupportAgentIcon, path: '/instructor/support' },
  ],

  manager: [
    { label: 'Dashboard', icon: HomeIcon, path: '/manager' },
    { label: 'Courses', icon: SchoolIcon, path: '/manager/courses' },
    {
      label: 'Students', icon: PeopleIcon, 
      children: [
        { label: 'All Students', path: '/manager/students' },
        { label: 'Filter Students', path: '/manager/student_filter' },
      ]
     },
    {
      label: 'Finance',
      icon: MonetizationOnIcon,
      children: [
        { label: 'Payments', icon: ReceiptIcon, path: '/manager/transactions' },
        { label: 'Expenses', icon: MonetizationOnIcon, path: '/manager/expenses' },
      ],
    },
    {
      label: 'Lessons',
      icon: DriveEtaIcon,
      children: [
        { label: 'Practical Lessons', path: '/manager/practical_lessons' },
        { label: 'Refresher Lessons', path: '/manager/refresher_lessons' },
      ],
    },
    { label: 'Support', icon: SupportAgentIcon, path: '/manager/support' },
    { label: 'Profile', icon: AccountCircleIcon, path: '/manager/profile' },
    
  ],

  student: [
    { label: 'Dashboard', icon: HomeIcon, path: '/student' },
    { label: 'My Enrollments', icon: SchoolIcon, path: '/student/my-courses' },
    {
      label: 'Moxy Courses',
      icon: SchoolIcon,
      children: [
        { label: 'Driving Courses', icon: DriveEtaIcon, path: '/student/driving' },
        { label: 'IT Courses', icon: LaptopIcon, path: '/student/computer' },
        { label: 'Refresher', icon: DriveEtaIcon, path: '/student/refresher' },
      ],
    },
    { label: 'Model Town Board', icon: GameIcon, path: '/student/model-town-board' },
    { label: 'Fee Payments', icon: PaymentsIcon, path: '/student/payments' },
    { label: 'Profile', icon: AccountCircleIcon, path: '/student/profile' },
    { label: 'Support', icon: SupportAgentIcon, path: '/student/support' },

  ],
};


